module.exports = __webpack_public_path__ + "img/bell_black.497b5fe8.svg";